/**
 * Authentication Service
 * OAuth 2.0 SSO via backend OpenID Connect (cookie-based sessions)
 * All URLs are relative -- Vite proxies /api, /login, /signin-oidc, /signout-oidc
 * to the backend in dev. In production, everything is same-origin.
 */

/**
 * Check if user is authenticated by calling the backend /api/auth/me endpoint
 */
export const isAuthenticated = async () => {
  try {
    const response = await fetch('/api/auth/me', {
      method: 'GET',
      credentials: 'include',
    })

    if (response.ok) {
      const data = await response.json()
      return data.isAuthenticated === true
    }
    return false
  } catch (error) {
    console.error('Error checking authentication:', error)
    return false
  }
}

/**
 * Get user info from the backend session
 */
export const getUserInfo = async () => {
  try {
    const response = await fetch('/api/auth/me', {
      method: 'GET',
      credentials: 'include',
    })

    if (response.ok) {
      const data = await response.json()
      if (data.isAuthenticated) {
        return {
          email: data.email,
          name: data.name || data.email,
          id: data.email,
          role: data.role || 'viewer',
        }
      }
    }
    return null
  } catch (error) {
    console.error('Error getting user info:', error)
    return null
  }
}

/**
 * Login - redirect to backend SSO login endpoint
 */
export const login = (returnUrl = '/dashboard') => {
  window.location.href = `/login?returnUrl=${encodeURIComponent(returnUrl)}`
}

/**
 * Logout - submits a POST form to the backend logout endpoint.
 * Uses a form POST (not GET) to prevent CSRF logout attacks.
 * Full browser navigation is required because the OIDC SignOut
 * returns a redirect chain through Azure AD that fetch can't follow.
 */
export const logout = () => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = '/api/auth/logout'
  document.body.appendChild(form)
  form.submit()
}
